export const userNavigation = {
  items: [
    {
      name: "Dashboard",
      url: "/user/dashboard",
    },
    {
      name: "AssetBox",
      url: "/user/Asset-box",
    },
    {
      name: "AssetShed",
      url: "/user/asset-shed",
    },
    {
      name: "Cart",
      url: "/user/cart",
    },
    {
      name: "Report",
      url: "/user/report",
    },
    {
      name: "ManageCenter",
      url: "/user/manage-center",
    },
  ],
};
